import { useTranslation } from 'react-i18next';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useMemo, useState } from 'react';
import {
  ChooseNewSlotType,
  Patient,
  usePatientStore,
} from '@store/patientStore';
import { OnlineBookingToast } from '@common/OnlineBookingToast';

export const ChooseNewSlot = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  // store
  const currentPatientIndex = useOnlineBookingStore(
    state => state.currentPatient,
  );
  const patients = usePatientStore(state => state.patients);
  const currentPatient: Patient | undefined = useMemo(() => {
    return patients && patients[currentPatientIndex];
  }, [patients, currentPatientIndex]);

  //states
  const ruleTime = useMemo(
    () => currentPatient?.extraInfoScheduleExam?.chooseNewSlot?.ruleTime,
    [currentPatient],
  );

  const ruleUnit = useMemo(
    () => currentPatient?.extraInfoScheduleExam?.chooseNewSlot?.ruleUnit,
    [currentPatient],
  );

  const appType = useMemo(
    () => patients[currentPatientIndex]?.appointmentType.name,
    [currentPatientIndex, patients],
  );

  const title = useMemo(() => {
    const type = currentPatient?.extraInfoScheduleExam?.chooseNewSlot?.type;

    return typeof type !== 'undefined'
      ? type === ChooseNewSlotType.INSURANCE
        ? t('calendarPage.chooseNewSlot.insuranceChangedTitle')
        : t('calendarPage.chooseNewSlot.appointmentChangedTitle')
      : '';
  }, [currentPatient, t]);

  const description = useMemo(() => {
    const type = currentPatient?.extraInfoScheduleExam?.chooseNewSlot?.type;
    return typeof type !== 'undefined'
      ? type === ChooseNewSlotType.INSURANCE
        ? t('calendarPage.chooseNewSlot.insuranceChangedDescription', {
            ruleTime: ruleTime,
            ruleUnit: ruleUnit?.toLowerCase(),
          })
        : t('calendarPage.chooseNewSlot.appointmentChangedDescription', {
            appType: appType,
          })
      : '';
  }, [currentPatient, appType, ruleTime, ruleUnit, t]);

  return (
    <OnlineBookingToast
      title={title}
      description={description}
      open={open}
      onClose={() => setOpen(false)}
    />
  );
};
